import React from 'react';
import { getEmojiStickerSrc } from '../EmojiStickerConfig';
import { parseMessageTextParts } from '../EmojiTextUtil';

interface MessageTextContentProps {
  text: string;
}

export const MessageTextContent: React.FC<MessageTextContentProps> = ({ text }) => {
  const parts = parseMessageTextParts(text);
  if (parts.length === 0) {
    return null;
  }

  return (
    <>
      {parts.map((part, index) => {
        if (part.kind === 'text') {
          return <React.Fragment key={`t-${index}`}>{part.text}</React.Fragment>;
        }
        const src = getEmojiStickerSrc(part.token);
        if (!src) {
          return (
            <React.Fragment key={`s-${index}`}>{`[${part.token}]`}</React.Fragment>
          );
        }
        return (
          <img
            key={`s-${index}`}
            src={src}
            alt={part.token}
            className="message-inline-sticker"
            draggable={false}
          />
        );
      })}
    </>
  );
};
